"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabbedDropdownTab = exports.TabbedDropdown = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var Popover_1 = tslib_1.__importDefault(require("@material-ui/core/Popover"));
var isEqual_1 = tslib_1.__importDefault(require("lodash/fp/isEqual"));
var TabbedDropdownButton_1 = tslib_1.__importDefault(require("./TabbedDropdownButton"));
var Components_1 = require("../../Components");
exports.TabbedDropdown = function (props) {
    var title = props.title, children = props.children, onChange = props.onChange, values = props.values;
    var anchorEl = react_1.useRef(null);
    var _a = react_1.useState(false), isDropdownOpen = _a[0], setIsDropdownOpen = _a[1];
    var _b = react_1.useState(false), isContentActive = _b[0], setIsContentActive = _b[1];
    var _c = react_1.useState(0), tabValue = _c[0], setTabValue = _c[1];
    var _d = react_1.useState(structuredClone(values)), draft = _d[0], updateDraft = _d[1];
    var _e = react_1.useState(false), isDirty = _e[0], setIsDirty = _e[1];
    var handleOnClick = react_1.useCallback(function (idx) {
        if (idx === void 0) { idx = 0; }
        setIsDropdownOpen(function (prev) { return !prev; });
        setTabValue(idx);
    }, []);
    var handleClose = react_1.useCallback(function () {
        setIsDropdownOpen(false);
    }, []);
    var handleCancel = react_1.useCallback(function () {
        handleClose();
        setTimeout(function () {
            updateDraft(structuredClone(values));
        }, 250);
    }, [handleClose, values]);
    var handleApply = react_1.useCallback(function () {
        if (onChange) {
            onChange(draft);
        }
        handleClose();
    }, [draft, handleClose, onChange]);
    var handleTabChange = function (_event, newValue) {
        setTabValue(newValue);
    };
    react_1.useEffect(function () {
        setTimeout(function () {
            setIsContentActive(isDropdownOpen);
        }, 250);
    }, [isDropdownOpen]);
    react_1.useEffect(function () {
        setIsDirty(!isEqual_1.default(draft, values));
    }, [draft, values]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(StyledContainer, { ref: anchorEl }, react_1.default.Children.map(children, function (_a, idx) {
            var label = _a.props.label;
            return (react_1.default.createElement(TabbedDropdownButton_1.default, { testID: "tabbedDropdown", onClick: function () { return handleOnClick(idx); }, isActive: isDropdownOpen && tabValue === idx, mode: "dark" }, label));
        })),
        react_1.default.createElement(StyledPopover, { hideBackdrop: false, BackdropProps: {
                invisible: false,
            }, anchorReference: "none", transformOrigin: {
                vertical: 'center',
                horizontal: 'center',
            }, open: isDropdownOpen, onClose: handleCancel, classes: { root: 'root', paper: 'paper' } },
            react_1.default.createElement(StyledHeader, null,
                react_1.default.createElement("span", null, title),
                react_1.default.createElement(CloseButton, { onClick: handleCancel },
                    react_1.default.createElement("i", { className: "icon--close" }))),
            isContentActive && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(Components_1.Tabs, { value: tabValue, onChange: handleTabChange }, react_1.default.Children.map(children, function (_a) {
                    var childProps = _a.props;
                    var label = childProps.label, tabLabel = childProps.tabLabel;
                    return react_1.default.createElement(Components_1.Tab, { label: tabLabel || label });
                })),
                react_1.default.createElement(StyledContentContainer, null, react_1.default.Children.map(children, function (child, idx) {
                    if (idx !== tabValue)
                        return null;
                    return react_1.default.cloneElement(child, {
                        value: draft ? draft[idx] : null,
                        onChange: function (newValue) {
                            updateDraft(function (prevState) {
                                var newState = structuredClone(prevState);
                                newState[idx] = newValue;
                                return newState;
                            });
                        },
                    });
                })),
                react_1.default.createElement(StyledFooter, null,
                    react_1.default.createElement(Components_1.Button, { onClick: handleCancel, buttonStyle: "SECONDARY" }, "Cancel"),
                    react_1.default.createElement(Components_1.Button, { onClick: handleApply, disabled: !isDirty }, "Apply")))))));
};
function TabbedDropdownTab(props) {
    var renderContent = props.renderContent, value = props.value, onChange = props.onChange;
    return renderContent({ value: value, onChange: onChange });
}
exports.TabbedDropdownTab = TabbedDropdownTab;
var StyledContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  align-self: flex-start;\n\n  & > * + * {\n    margin-top: 10px;\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-self: flex-start;\n\n  & > * + * {\n    margin-top: 10px;\n  }\n"])));
var StyledPopover = styled_components_1.default(Popover_1.default)(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  &&.root {\n    z-index: 10010 !important;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n  .paper {\n    font-family: ", ";\n    display: flex;\n    flex-direction: column;\n    border-radius: 0;\n    padding: 0;\n    width: 630px;\n    height: 895px;\n    position: relative;\n  }\n"], ["\n  &&.root {\n    z-index: 10010 !important;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n  .paper {\n    font-family: ", ";\n    display: flex;\n    flex-direction: column;\n    border-radius: 0;\n    padding: 0;\n    width: 630px;\n    height: 895px;\n    position: relative;\n  }\n"])), function (props) { return props.theme.fonts.robotoRegular; });
var StyledHeader = styled_components_1.default.div(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  font-family: ", ";\n  color: ", ";\n  padding: 12px 16px 16px 24px;\n  font-size: 18px;\n  line-height: 1.333em;\n  font-weight: 500;\n  border-bottom: 1px solid #eaeaea;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n"], ["\n  font-family: ", ";\n  color: ", ";\n  padding: 12px 16px 16px 24px;\n  font-size: 18px;\n  line-height: 1.333em;\n  font-weight: 500;\n  border-bottom: 1px solid #eaeaea;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n"])), function (props) { return props.theme.fonts.robotoMedium; }, function (_a) {
    var theme = _a.theme;
    return theme.colors.NTDarkGrey[900];
});
var CloseButton = styled_components_1.default.button(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n  background: none;\n  border: none;\n  padding: 8px;\n\n  i {\n    font-size: 24px;\n  }\n"], ["\n  background: none;\n  border: none;\n  padding: 8px;\n\n  i {\n    font-size: 24px;\n  }\n"])));
var StyledContentContainer = styled_components_1.default.div(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["\n  flex: 1;\n  overflow: hidden;\n"], ["\n  flex: 1;\n  overflow: hidden;\n"])));
var StyledFooter = styled_components_1.default.div(templateObject_6 || (templateObject_6 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  padding: 16px 24px;\n  background: ", ";\n  border-top: 1px solid ", ";\n  justify-content: flex-end;\n\n  & > button + button {\n    margin-left: 8px;\n  }\n"], ["\n  display: flex;\n  padding: 16px 24px;\n  background: ", ";\n  border-top: 1px solid ", ";\n  justify-content: flex-end;\n\n  & > button + button {\n    margin-left: 8px;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.NTDarkGrey[50];
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.NTDarkGrey[100];
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
